export const SWIMLANE_COLUMN_DEFAULT_WIDTH = 275;
export const SWIMLANE_COLUMN_MIN_WIDTH = 180;
export const SWIMLANE_COLUMN_MAX_WIDTH = 720;

const SWIMLANE_COLUMN_WIDTH_STORAGE_VERSION = 1;
const SWIMLANE_COLUMN_WIDTH_STORAGE_PREFIX =
  'cinebudget-swimlane-column-widths';

const getStorageKey = budgetId =>
  budgetId ? `${SWIMLANE_COLUMN_WIDTH_STORAGE_PREFIX}:${budgetId}` : null;

export const getSwimlaneColumnWidthKey = swimlaneIndex =>
  `column:${
    Number.isFinite(Number(swimlaneIndex)) ? Number(swimlaneIndex) : 0
  }`;

export const normalizeSwimlaneColumnWidth = value => {
  const parsed = Number.parseFloat(String(value || '').replace('px', ''));

  if (!Number.isFinite(parsed)) return null;

  return Math.min(
    Math.max(Math.round(parsed), SWIMLANE_COLUMN_MIN_WIDTH),
    SWIMLANE_COLUMN_MAX_WIDTH
  );
};

export const readStoredSwimlaneColumnWidths = budgetId => {
  const storageKey = getStorageKey(budgetId);
  if (typeof window === 'undefined' || !storageKey) return {};

  try {
    const stored = JSON.parse(
      window.localStorage?.getItem(storageKey) || 'null'
    );

    if (stored?.version !== SWIMLANE_COLUMN_WIDTH_STORAGE_VERSION) return {};

    return Object.entries(stored.widths || {}).reduce((acc, [key, value]) => {
      const width = normalizeSwimlaneColumnWidth(value);
      if (width) acc[key] = width;
      return acc;
    }, {});
  } catch {
    return {};
  }
};

export const readStoredSwimlaneColumnWidth = (budgetId, columnKey) =>
  readStoredSwimlaneColumnWidths(budgetId)?.[columnKey] || null;

export const writeStoredSwimlaneColumnWidth = (budgetId, columnKey, width) => {
  const storageKey = getStorageKey(budgetId);
  const normalizedWidth = normalizeSwimlaneColumnWidth(width);

  if (
    typeof window === 'undefined' ||
    !storageKey ||
    !columnKey ||
    !normalizedWidth
  ) {
    return;
  }

  try {
    window.localStorage?.setItem(
      storageKey,
      JSON.stringify({
        version: SWIMLANE_COLUMN_WIDTH_STORAGE_VERSION,
        widths: {
          ...readStoredSwimlaneColumnWidths(budgetId),
          [columnKey]: normalizedWidth,
        },
      })
    );
  } catch {
    // Ignore storage failures; in-memory sizing still applies.
  }
};
